<template>
    <comHeader></comHeader>
        <!-- inner banner -->
        <div class="inner-banner">
        <div class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">技术支持</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">主页</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>技术支持</li>
                </ul>
            </div>
        </div>
    </div>
    <!-- //inner banner -->

    <section class="w3l-about-2 py-5">
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
                <div class="about-2-secs-left pr-lg-5">
                    <h1 class="title-style mb-sm-3 mb-2">1. 智能身份证标签是如何工作的？</h1>
                    <div></div>
                    <p class="w3l-grids-block-5 font-stle">
                        该标签使用QR码直接链接到您的宠物的资料。如果你的宠物被找到，任何人都可以用智能手机扫描或点击标签来获取他们的信息并联系你。
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">2.如何创建宠物的个人资料？</h3>
                    <ul>
                        <li>1. 扫描产品上的二维码</li>
                        <li>2. 注册账户</li>
                        <li>3.点击添加标签，输入激活码</li>
                        <li>4.编辑标签信息并保存</li>
                        <li>5. 设置完成</li>
                    </ul>
                    <h3 class="title-style mb-sm-3 mb-2 title">3.宠物身份标签二维码如何使用？</h3>
                    <p>二维码宠物标签是一种数字宠物身份识别标签。这些标签上没有打印的姓名和电话号码，而是带有一个二维码，可以链接到宠物主人的联系方式。当有人扫描代码时，他们会获得宠物主人的联系信息。因此，他们可以无缝地联系主人并告知他们有关宠物的信息。</p>
                    <div>
                        <ul>
                            <li>
                                <p>步骤 1</p>
                                <p>获取宠物身份标签并为您的宠物创建个人资料。
                                链接个人资料和标签，保持您的联系方式和宠物的重要信息为最新。</p>
                            </li>
                            <li>
                                <p>步骤 2</p>
                                <p>如果您的宠物失踪。
确保您已启用所有关键信息，以便查找者可以通过您的宠物的个人资料查看它们。</p>
                            </li>
                            <li>
                                <p>步骤 3</p>
                                <p>扫描标签或在线访问个人资料。
任何拥有智能手机的人都可以扫描标签或在线访问您的宠物的个人资料，以查看您的联系方式和宠物的重要信息。</p>
                            </li>
                            <li>
                                <p>步骤 4</p>
                                <p>与你的宠物团聚。
有了详细的联系信息，拾获者可以立即联系您，您的宠物也能更快地回家。</p>
                            </li>
                        </ul>
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2 title">4. 我需要订阅吗？</h3>
                    <p>
                       不！Smart ID没有订阅费或隐藏费用。
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">5. 我可以在宠物的个人资料中添加哪些信息？</h3>
                    <p>您可以包括您的宠物的名字，您的联系方式，以及任何有助于保护您的宠物安全的特殊说明。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">6. 没有应用程序也能用吗？</h3>
                    <p>是的，不需要下载一个页面。该标签适用于任何能够扫描QR码的智能手机。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">7. 我的信息安全吗？</h3>
                    <p>是的，您的详细信息会被安全地保存，个人数据可在未经授权的情况下设置为隐藏模式。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">8. 如果我需要更新我的宠物信息怎么办？</h3>
                    <p>您可以随时通过扫描二维码登录您的账户来更新您的宠物的资料。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">9. 这个标签会追踪我的宠物的位置吗？</h3>
                    <p>不，智能ID标签不是GPS追踪器。它通过向找到宠物的人提供您的联系信息，帮助你重新与宠物联系起来。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">10. 它在全球范围内有效吗？</h3>
                    <p>是的，标签可以在世界任何地方被扫描。</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">如果我不能收到验证码，我该怎么办？</h3>
                    <div>
                        <ul>
                            <li>1). 请验证您输入的电子邮件地址是否正确。 </li>
                            <li>2). 检查垃圾邮件和促销邮件文件夹以查找代码。</li>
                            <li>3). 您的邮箱空间不足。</li>
                            <li>4). 请点击首页右上方留言按钮进行客服。</li>
                        </ul>
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2 title">12. 如果我不能收到验证码，我该怎么办？</h3>
                    <p>
                        您可以点击“忘记密码”重置密码。
                    </p>

                    <h3 class="title-style mb-sm-3 mb-2 title">13. 如果显示激活码错误或已被使用，我该怎么办？</h3>
                    <p>请先检查您是否收到了正确的激活码。如果输入了正确的激活码，但仍显示激活码错误，如果二维码不起作用，请联系客户服务部或购买网站的商家。
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">14. 如何为我的帐户更改电子邮件？</h3>
                    <p>您可以登录账户，删除 “我的标签 ”页面上的标签。然后扫描标签上的二维码，用新的电子邮件地址重新注册一个新账户。</p>
                </div>
            </div>
        </div>
    </section>

  </template>
  
  <script>
  import comHeader from '../components/comHeader.vue';

  export default {
    name: 'appSupport',
    components:{
      comHeader
    }
  }
  </script>
  
  <style scoped>
  /* 可添加样式 */
  </style>